import { Button,Dropdown } from 'antd'
import React from 'react'
import taqdimot_1 from '../fayl/taqdimot/1.pdf'
import taqdimot_2 from '../fayl/taqdimot/2.pdf'
import taqdimot_3 from '../fayl/taqdimot/3.pdf'
import taqdimot_4 from '../fayl/taqdimot/4.pdf'
import taqdimot_5 from '../fayl/taqdimot/5.pdf'
import taqdimot_6 from '../fayl/taqdimot/6.pdf'
import taqdimot_7 from '../fayl/taqdimot/7.pdf'
import taqdimot_8 from '../fayl/taqdimot/8.pdf'
import taqdimot_9 from '../fayl/taqdimot/9.pdf'
import taqdimot_10 from '../fayl/taqdimot/10.pdf'
import taqdimot_11 from '../fayl/taqdimot/11.pdf'
import taqdimot_12 from '../fayl/taqdimot/12.pdf'
import taqdimot_13 from '../fayl/taqdimot/13.pdf'
import taqdimot_14 from '../fayl/taqdimot/14.pdf'
import taqdimot_15 from '../fayl/taqdimot/15.pdf'

const items =[
    {
        key: '1',
        label: ( <a href={taqdimot_1}>1-taqdimot</a> )
    },
    {
        key: '2',
        label: ( <a href={taqdimot_2}>2-taqdimot</a> )
    },
    {
        key: '3',
        label: ( <a href={taqdimot_3}>3-taqdimot</a> )
    },
    {
        key: '4',
        label: ( <a href={taqdimot_4}>4-taqdimot</a> )
    },
    {
        key: '5',
        label: ( <a href={taqdimot_5}>5-taqdimot</a> )
    },
    {
        key: '6',
        label: ( <a href={taqdimot_6}>6-taqdimot</a> )
    },
    {
        key: '7',
        label: ( <a href={taqdimot_7}>7-taqdimot</a> )
    },
    {
        key: '8',
        label: ( <a href={taqdimot_8}>8-taqdimot</a> )
    },
    {
        key: '9',
        label: ( <a href={taqdimot_9}>9-taqdimot</a> )
    },
    {
        key: '10',
        label: ( <a href={taqdimot_10}>10-taqdimot</a> )
    },
    {
        key: '11',
        label: ( <a href={taqdimot_11}>11-taqdimot</a> )
    },
    {
        key: '12',
        label: ( <a href={taqdimot_12}>12-taqdimot</a> )
    },
    {
        key: '13',
        label: ( <a href={taqdimot_13}>13-taqdimot</a> )
    },
    {
        key: '14',
        label: ( <a href={taqdimot_14}>14-taqdimot</a> )
    },
    {
        key: '15',
        label: ( <a href={taqdimot_15}>15-taqdimot</a> )
    },
]

export const Taqdimot = () => {
  return (
    <div>
        <Dropdown menu={{items}} placement='bottom' arrow={{pointAtCenter: true}}>
            <Button className='button'>Taqdimotlar</Button>
        </Dropdown>
    </div>
  )
}
